export const coverManagerConstants = {
    COVER_MANAGER_RESTAURANTS_SUCCESS: 'COVER_MANAGER_RESTAURANTS_SUCCESS',
    COVER_MANAGER_RESTAURANTS_ERROR: 'COVER_MANAGER_RESTAURANTS_ERROR',
    COVER_MANAGER_RESTAURANTS_REQUEST: 'COVER_MANAGER_RESTAURANTS_REQUEST',
    COVER_MANAGER_RESTAURANTS_RESET: 'COVER_MANAGER_RESTAURANTS_RESET',
};
